


























































import getVSelectOptionByValue from "piramis-js-utils/lib/getVSelectOptionByValue";
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';

import ModelSetter from "../../Mixins/ModelSetter";
import { timezoneList } from "../../logic/timizone-list";
import SelectInput from '../Pi/fields/SelectInput/SelectInput.vue';
import { SetTimezonePayload } from "./types";

@Component({
  data() {
    return {
      timezoneList
    }
  },
  components: {
    SelectInput,
  }
})
export default class TimezonePicker extends Mixins(ModelSetter) {
  @Prop({ type: Boolean }) disabled!: boolean

  @Prop({ type: String }) timezone!: string

  @Prop({ type: String, default: '', required: false }) prefix!: string

  @Watch('timezone', { immediate: true })
  onPropTimezoneChange(tz: string) {
    this.value = tz
  }

  isTimezoneSaving = false

  isTimezoneModalOpen = false

  value = ''

  get timezoneLabel() {
    return getVSelectOptionByValue(timezoneList, this.timezone)?.label ?? '-'
  }

  @Emit()
  setTimezone(timezone: string): SetTimezonePayload {
    return {
      timezone,
      closeLoader: () => {
        this.isTimezoneSaving = false
      },
      closeModal: () => {
        this.isTimezoneModalOpen = false
      }
    }
  }

  approveTimezone() {
    this.isTimezoneSaving = true

    this.setTimezone(this.value)
  }

  afterClose() {
    this.value = this.timezone
  }
}
